var _path, _path2, _path3, _circle, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPerformance(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 55,
    viewBox: "0 0 53 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8675 52.7525L26.5725 37.5404L34.0725 45.4168L46.2421 33.2471",
    stroke: "#4BB543",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0424 28.9605L43.5384 30.233C42.7291 30.3914 42.4485 31.4061 43.0615 31.9577L48.1515 36.5388C48.7146 37.0455 49.6147 36.7666 49.7925 36.0303L51.2064 30.1767C51.3776 29.4682 50.7577 28.8206 50.0424 28.9605Z",
    fill: "#4BB543",
    stroke: "#4BB543",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5076 23.5528C2.30314 30.5745 5.39921 36.9423 10.4196 41.2282L13.5725 37.1611M2.5076 23.5528L8.57251 23.5528M2.5076 23.5528C2.67963 17.6449 5.1572 12.3352 9.07251 8.42487M26.2071 1.67097C38.1859 2.01978 47.7694 11.2525 48.5513 22.7231M26.2071 1.67097L26.2071 8.16113M26.2071 1.67097C19.5172 1.47617 13.4118 4.09106 9.07251 8.42487M9.07251 8.42487L13.5725 12.6611",
    stroke: "#4BB543",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0725,
    cy: 25.1611,
    r: 4.5,
    fill: "#4BB543"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5725 14.6842C35.1878 14.2995 28.6067 18.8165 24.9901 21.3867C24.7268 21.5738 24.5725 21.8759 24.5725 22.1988V24.6846C24.5725 25.2369 25.0202 25.6846 25.5725 25.6846H28.0579C28.3808 25.6846 28.6829 25.5303 28.87 25.267C31.4402 21.6502 35.9572 15.0689 35.5725 14.6842Z",
    fill: "#4BB543",
    stroke: "#4BB543",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.5285820adeec329910307855258ca07d.svg";
export { ForwardRef as ReactComponent };